module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "to-top"
  }, [(!_vm.isXS) ? _c('div', {
    staticClass: "to-top--displacer",
    style: (_vm.scrollLockStyles)
  }, [_c('div', {
    staticClass: "to-top--wrap",
    style: (_vm.wrapStyles)
  }, [_c('transition', {
    attrs: {
      "name": "trs-simple-fade"
    }
  }, [(_vm.isShown) ? _c('button', {
    staticClass: "to-top--button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.requestScrollTop()
      }
    }
  }, [_c('span', {
    staticClass: "to-top--text",
    domProps: {
      "textContent": _vm._s(_vm.translate('TO_TOP.LABEL'))
    }
  }), _vm._v(" "), _c('cmp-icon', {
    staticClass: "to-top--icon",
    attrs: {
      "symbol": "chevron_right",
      "size": "x-small"
    }
  })], 1) : _vm._e()])], 1)]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1ca28190", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ca28190","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/to-top/index.vue
// module id = 512
// module chunks = 7